import { Box, FormControlLabel, Paper, Switch, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

interface PerformanceStats {
  memory: number;
  apiCalls: number;
  slowRenders: number;
}

export function PerformanceDebugger() {
  const [isVisible, setIsVisible] = useState(false);
  const [stats, setStats] = useState<PerformanceStats>({
    memory: 0,
    apiCalls: 0,
    slowRenders: 0,
  });

  useEffect(() => {
    if (!import.meta.env.DEV) return;

    const updateStats = () => {
      const memory = (performance as unknown as { memory?: { usedJSHeapSize: number } }).memory;
      if (memory) {
        setStats(prev => ({
          ...prev,
          memory: Math.round(memory.usedJSHeapSize / 1024 / 1024),
        }));
      }
    };

    const interval = setInterval(updateStats, 2000);
    return () => clearInterval(interval);
  }, []);

  if (!import.meta.env.DEV || !isVisible) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 10,
          right: 10,
          zIndex: 9999,
        }}
      >
        <FormControlLabel
          control={
            <Switch
              checked={isVisible}
              onChange={e => setIsVisible(e.target.checked)}
              size="small"
            />
          }
          label="Perf"
          sx={{
            fontSize: '12px',
            '& .MuiFormControlLabel-label': { fontSize: '12px' },
          }}
        />
      </Box>
    );
  }

  return (
    <Paper
      sx={{
        position: 'fixed',
        top: 10,
        right: 10,
        p: 1,
        minWidth: 200,
        zIndex: 9999,
        fontSize: '12px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 1,
        }}
      >
        <Typography variant="caption" fontWeight="bold">
          Performance
        </Typography>
        <Switch checked={isVisible} onChange={e => setIsVisible(e.target.checked)} size="small" />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        <Typography variant="caption">Memory: {stats.memory}MB</Typography>
        <Typography variant="caption">API Calls: {stats.apiCalls}</Typography>
        <Typography variant="caption">Slow Renders: {stats.slowRenders}</Typography>
        <Typography variant="caption" sx={{ fontSize: '10px', opacity: 0.7 }}>
          Check console for detailed logs
        </Typography>
      </Box>
    </Paper>
  );
}
